import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import '../use_cases/UseCasePages.css';
import './MCPConnectionsGuide.css';
import shieldLogo from '../../assets/shield_logo.png';
import logoRotate from '../../assets/movie/logo_rotate_large_v2.gif';
import mcpIcon from '../../assets/tools/mcp_white.png';
import claudeIcon from '../../assets/tools/anthropic.png';
import openaiIcon from '../../assets/openaicircle_dark.png';
import openaiLightIcon from '../../assets/openaicircle.png';
import geminiIcon from '../../assets/geminicircle.png';
import driveIcon from '../../assets/googledrive.png';
import sharepointIcon from '../../assets/sharepoint.png';
import outlookIcon from '../../assets/ms_outlook.png';
import jiraIcon from '../../assets/jira.png';
import slackIcon from '../../assets/slack.png';
import githubIcon from '../../assets/githubcircle.png';
import dbIcon from '../../assets/tools/database.png';
import stackIcon from '../../assets/tools/stack.png';

// BLTZ-912: every figure on this page is sourced inline. The product numbers come
// from the shipped policy set in browser_policy_file, not from marketing.

/* Inline so the colour is ours. The PNG marks in the icon set are white glyphs,
   which vanish on the light cards this page uses. */
const IconBug = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M8 6a4 4 0 0 1 8 0" /><rect x="7" y="8" width="10" height="12" rx="5" />
    <path d="M3 12h4M17 12h4M4 7l3 2M20 7l-3 2M4 18l3-2M20 18l-3-2" />
  </svg>
);
const IconAlert = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
    <path d="M12 9v4M12 17h.01" />
  </svg>
);
const IconChain = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" />
    <path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" />
  </svg>
);
const IconGavel = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M14 3 21 10M17.5 6.5 13 11M10 7l7 7" />
    <path d="M9.5 8.5 3 15a2.1 2.1 0 0 0 3 3l6.5-6.5" /><path d="M13 21h8" />
  </svg>
);
const IconEyeOff = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M9.9 4.2A10 10 0 0 1 12 4c6 0 10 8 10 8a18 18 0 0 1-3 4" />
    <path d="M6.3 6.3A18 18 0 0 0 2 12s4 8 10 8a10 10 0 0 0 4.3-1" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2M2 2l20 20" />
  </svg>
);
const IconEvidence = () => (
  <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="8" cy="8" r="6.5" /><path d="M8 5v3.5M8 11h.01" />
  </svg>
);

const IconTrend = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 17l6-6 4 4 7-7" /><path d="M14 8h6v6" />
  </svg>
);
const IconBreach = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 3 4 6v6c0 5 3.4 8.4 8 9 4.6-.6 8-4 8-9V6Z" />
    <path d="M12 8.5v4M12 16h.01" />
  </svg>
);
const IconCost = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="9" /><path d="M15 9.2A3.2 3.2 0 0 0 12 7.5c-1.7 0-3 .9-3 2.2 0 3 6 1.6 6 4.6 0 1.3-1.3 2.2-3 2.2a3.2 3.2 0 0 1-3-1.7" />
    <path d="M12 6v12" />
  </svg>
);
const IconGap = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 21a9 9 0 1 1 9-9" /><path d="M12 12l4.5 4.5" />
    <path d="M17 19h6M20 16v6" />
  </svg>
);
const IconConnection = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="5" cy="12" r="2.6" /><circle cx="18" cy="6" r="2.6" /><circle cx="18" cy="18" r="2.6" />
    <path d="M7.5 10.8 15.6 7.2M7.5 13.2l8.1 3.6" />
  </svg>
);

const ArrowUp = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
    <path d="M5 1 L9 7 H1 Z" fill="currentColor" />
  </svg>
);

const ArrowDown = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
    <path d="M5 9 L1 3 H9 Z" fill="currentColor" />
  </svg>
);

const HEADLINE_STATS = [
  {
    tone: 'warn', dir: 'up', tag: 'Exposure rising', value: '970x', Icon: IconTrend,
    label: 'Growth in monthly MCP SDK downloads in sixteen months, to 97 million',
    src: 'Anthropic, December 2025', href: 'https://www.anthropic.com/news/donating-the-model-context-protocol-and-establishing-of-the-agentic-ai-foundation',
  },
  {
    tone: 'bad', dir: 'up', tag: 'Worsening', value: '43%', Icon: IconBreach,
    label: 'Of breaches involved shadow AI in 2026, up from 20% the year before',
    src: 'IBM Cost of a Data Breach 2026', href: 'https://www.ibm.com/reports/data-breach',
  },
  {
    tone: 'bad', dir: 'up', tag: 'Cost', value: '$670K', Icon: IconCost,
    label: 'Added cost per breach where shadow AI is prevalent, against organisations with little or none',
    src: 'IBM Cost of a Data Breach 2026', href: 'https://www.ibm.com/reports/data-breach',
  },
  {
    tone: 'gap', dir: 'down', tag: 'Control gap', value: '37%', Icon: IconGap,
    label: 'Of organisations have any AI detection or governance policy in place',
    src: 'IBM Cost of a Data Breach 2026', href: 'https://www.ibm.com/reports/data-breach',
  },
];

const SCAN_FINDINGS = [
  { label: 'File operations exposed to path traversal', pct: 82, n: 'Endor Labs, 2,614 servers' },
  { label: 'At least one security finding', pct: 66, n: 'AgentSeal, 1,808 servers' },
  { label: 'Vulnerable to command injection', pct: 43, n: 'Equixly, 2025 to Feb 2026' },
  { label: 'Vulnerable to server-side request forgery', pct: 36.7, n: 'BlueRock, 7,000+ servers' },
];

/* Below 700px the chart viewBox scales to roughly 0.44, which puts a 13px label at
   about 6px. The figures are served as text there instead. */
const ChartFallback = ({ rows, caption }) => (
  <div className="mcp-chart-fallback">
    <ul className="mcp-figure-list">
      {rows.map(r => (
        <li key={r.label}>
          <span className="mcp-figure-value">{r.value}</span>
          <span className="mcp-figure-label">{r.label}</span>
          {r.n && <span className="mcp-figure-src">{r.n}</span>}
        </li>
      ))}
    </ul>
    {caption && <p className="mcp-figure-caption">{caption}</p>}
  </div>
);

const ScanChart = () => {
  const rowH = 58;
  const barX = 330;
  const barW = 320;
  const h = SCAN_FINDINGS.length * rowH + 28;
  return (
    <>
    <svg className="mcp-chart-svg" viewBox={`0 0 720 ${h}`} width="100%" role="img"
      aria-label="Share of scanned MCP servers carrying each weakness: 82 percent path traversal, 66 percent any finding, 43 percent command injection, 36.7 percent server-side request forgery.">
      {[0, 25, 50, 75, 100].map(t => (
        <g key={t}>
          <line x1={barX + (barW * t) / 100} y1="6" x2={barX + (barW * t) / 100} y2={h - 22}
            stroke="#ece8f5" strokeWidth="1" />
          <text x={barX + (barW * t) / 100} y={h - 6} textAnchor="middle"
            fontSize="11" fill="#8a84a0" fontFamily="Inter, sans-serif">{t}%</text>
        </g>
      ))}
      {SCAN_FINDINGS.map((d, i) => {
        const y = 14 + i * rowH;
        return (
          <g key={d.label}>
            <text x={barX - 14} y={y + 14} textAnchor="end" fontSize="13" fontWeight="600"
              fill="#1a1a2e" fontFamily="Inter, sans-serif">{d.label}</text>
            <text x={barX - 14} y={y + 31} textAnchor="end" fontSize="11"
              fill="#8a84a0" fontFamily="Inter, sans-serif">{d.n}</text>
            <rect x={barX} y={y} width={(barW * d.pct) / 100} height="25" rx="4" fill="#6a1fcf" />
            <text x={barX + (barW * d.pct) / 100 + 10} y={y + 18} fontSize="14" fontWeight="800"
              fill="#5803c8" fontFamily="Inter, sans-serif">{d.pct}%</text>
          </g>
        );
      })}
    </svg>
    <ChartFallback rows={SCAN_FINDINGS.map(d => ({ label: d.label, value: d.pct + '%', n: d.n }))} />
    </>
  );
};

const AdoptionChart = () => (
  <>
  <svg className="mcp-chart-svg" viewBox="0 0 720 250" width="100%" role="img"
    aria-label="Enterprise AI teams running at least one MCP-backed agent in production rose from 31 percent in Q1 2025 to 78 percent in Q1 2026.">
    {[0, 25, 50, 75, 100].map(t => (
      <g key={t}>
        <line x1="70" y1={196 - (t * 1.6)} x2="700" y2={196 - (t * 1.6)} stroke="#ece8f5" strokeWidth="1" />
        <text x="58" y={200 - (t * 1.6)} textAnchor="end" fontSize="11" fill="#8a84a0"
          fontFamily="Inter, sans-serif">{t}%</text>
      </g>
    ))}
    <rect x="170" y={196 - 31 * 1.6} width="140" height={31 * 1.6} rx="5" fill="#c9b6ec" />
    <text x="240" y={196 - 31 * 1.6 - 12} textAnchor="middle" fontSize="20" fontWeight="800"
      fill="#5803c8" fontFamily="Inter, sans-serif">31%</text>
    <text x="240" y="218" textAnchor="middle" fontSize="12" fill="#3a3a5c"
      fontFamily="Inter, sans-serif">Q1 2025</text>
    <rect x="450" y={196 - 78 * 1.6} width="140" height={78 * 1.6} rx="5" fill="#6a1fcf" />
    <text x="520" y={196 - 78 * 1.6 - 12} textAnchor="middle" fontSize="20" fontWeight="800"
      fill="#5803c8" fontFamily="Inter, sans-serif">78%</text>
    <text x="520" y="218" textAnchor="middle" fontSize="12" fill="#3a3a5c"
      fontFamily="Inter, sans-serif">Q1 2026</text>
    <text x="385" y="240" textAnchor="middle" fontSize="11" fill="#8a84a0" fontFamily="Inter, sans-serif">
      Enterprise AI teams of 50+ practitioners with at least one MCP-backed agent in production
    </text>
  </svg>
  <ChartFallback
    rows={[
      { label: 'Q1 2025', value: '31%' },
      { label: 'Q1 2026', value: '78%' },
    ]}
    caption="Enterprise AI teams of 50+ practitioners with at least one MCP-backed agent in production"
  />
  </>
);

const RISK_CARDS = [
  {
    Icon: IconBug, title: 'Tool poisoning',
    body: 'An MCP server describes its own tools to the model in natural language. Nothing sanitises that text and the user never sees it, so the description is an instruction channel pointed at the model, written by whoever controls the server.',
    evidence: 'The MCPTox benchmark measured a 36.5% average attack success rate across twenty models, rising to 72.8% against the weakest. An academic scan of 1,899 servers found about 5.5% already carrying tool poisoning patterns.',
  },
  {
    Icon: IconAlert, title: 'No isolation to escape',
    body: 'Cloud Security Alliance research published in July 2026 documented that Cursor, Claude Code, Gemini CLI, GitHub Copilot and Amazon Q Developer all auto-execute project-defined MCP servers with the developer’s own operating system privileges.',
    evidence: 'A proof of concept in April 2025 used a poisoned calculator tool to exfiltrate an SSH private key. The tool did arithmetic correctly the whole time.',
    links: [{ text: 'Cloud Security Alliance research note', href: 'https://labs.cloudsecurityalliance.org/research/csa-research-note-mcp-tool-poisoning-auto-execution-20260701/' }],
  },
  {
    Icon: IconAlert, title: 'Already exploited',
    body: 'More than 30 CVEs were filed against MCP servers in a single sixty-day window in early 2026, the majority of them command injection patterns.',
    evidence: 'CVE-2025-6514, scored 9.6, gave remote code execution through mcp-remote, a package with over 437,000 downloads. CVE-2026-33032, scored 9.8, was reported as actively exploited in March 2026. Wiz disclosed two Amazon Q flaws in June 2026.',
    links: [
      { text: 'CVE-2025-6514', href: 'https://www.cve.org/CVERecord?id=CVE-2025-6514' },
      { text: 'CVE-2026-33032', href: 'https://www.cve.org/CVERecord?id=CVE-2026-33032' },
    ],
  },
  {
    Icon: IconChain, title: 'Supply chain and exposure',
    body: 'A malicious version of postmark-mcp silently blind-copied every email it handled. The Miasma campaign planted adversarial MCP configuration files across 73 GitHub repositories in June 2026, including one belonging to Microsoft.',
    evidence: 'Trend Micro found 492 MCP servers on the public internet with no authentication in July 2025, later counted at 1,467. Researchers found 24,008 secrets committed in MCP configuration files on public GitHub, of which 2,117 were still valid.',
  },
];

const REG_CARDS = [
  {
    title: 'DORA', sub: 'Register of Information',
    body: 'In-scope financial entities had to submit a complete inventory of ICT third-party contracts to their national regulator by 31 March 2026.',
    evidence: 'A connection nobody recorded is an ICT dependency missing from a register that has already been filed.',
  },
  {
    title: 'NIS2', sub: 'Active supervision',
    body: 'Enforcement moved from transposition to inspection during 2026, with member states specifically testing whether organisations can demonstrate systematic oversight of supplier security posture.',
    evidence: 'Oversight you cannot evidence is oversight you do not have.',
  },
  {
    title: 'EU AI Act', sub: 'High-risk obligations',
    body: 'Obligations for high-risk systems began applying in August 2026, including due diligence over the AI components an organisation puts into use.',
    evidence: 'Due diligence presumes you know which AI components are in use. Self-service connections are the ones you do not know about.',
  },
  {
    title: 'GDPR', sub: 'Processor obligations',
    body: 'An employee completing an OAuth grant has routed personal data to a processor, on the company’s behalf, with no data processing agreement and no record of processing.',
    evidence: 'The obligation attaches whether or not anyone in compliance knew the connection was made.',
  },
];

const BLIND_SPOTS = [
  { title: 'CASB and SWG', body: 'Traffic to an approved domain, inside an authenticated session, over TLS. The vendor is sanctioned and the destination is on the allow list.', evidence: 'Nothing anomalous. A connection and an ordinary chat look identical at the network boundary.' },
  { title: 'DLP and email security', body: 'No file is downloaded, no attachment is sent, and no document crosses a monitored channel at the moment of connection.', evidence: 'The data movement happens later, server to server, between two parties the employee introduced.' },
  { title: 'SaaS and identity governance', body: 'No new subscription, no new SSO application, no procurement event. The grant is made inside an application that was already approved.', evidence: 'The integration never appears in the SaaS inventory it should belong to.' },
  { title: 'AI prompt monitoring', body: 'Prompts are captured. Connecting a tool is not a prompt, so it does not appear in prompt logs at all.', evidence: 'The control built specifically for AI misses the specifically AI-native event.' },
];

const SHIPPED = [
  { Icon: IconConnection, value: '240', label: 'Connection policies shipped across ChatGPT, Claude and Gemini' },
  { icon: claudeIcon, value: '141', label: 'Claude connectors and MCP servers, each keyed on its MCP server URL' },
  { icon: openaiLightIcon, value: '93', label: 'ChatGPT directory apps, the full published directory plus a catch-all' },
  { icon: shieldLogo, value: '3', label: 'Actions per policy: log it, warn the user, or block the connection' },
];

const MCPConnectionsGuide = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(true);

  const sectionIds = ['uc-hero', 'section-what', 'section-scale', 'section-data', 'section-threat',
    'section-regulatory', 'section-blindspot', 'section-shipped', 'section-cta'];

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight;
      const winHeight = window.innerHeight;
      setCanScrollUp(scrollTop > 10);
      setCanScrollDown(scrollTop + winHeight < docHeight - 10);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = useCallback((direction) => {
    const currentScroll = window.scrollY;
    const nav = document.querySelector('.nav-container');
    const navH = nav ? nav.offsetHeight : 64;
    const positions = sectionIds.map(id => {
      const el = document.getElementById(id);
      if (!el) return null;
      const title = el.querySelector('h2, p');
      const target = title || el;
      return { scrollTo: target.getBoundingClientRect().top + window.scrollY - navH - 40 };
    }).filter(Boolean);

    if (direction === 'down') {
      const next = positions.find(p => p.scrollTo > currentScroll + 10);
      if (next) window.scrollTo({ top: next.scrollTo, behavior: 'smooth' });
    } else {
      const prev = [...positions].reverse().find(p => p.scrollTo < currentScroll - 10);
      if (prev) window.scrollTo({ top: prev.scrollTo, behavior: 'smooth' });
    }
  }, []);

  return (
    <>
      <div className="scroll-float-wrap">
        {canScrollUp && (
          <button className="scroll-float-bubble scroll-bubble-dark" onClick={() => scrollToSection('up')} aria-label="Scroll up">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none"><polygon points="12,6 4,16 20,16" fill="currentColor" /></svg>
          </button>
        )}
        {canScrollDown && (
          <button className="scroll-float-bubble scroll-bubble-dark" onClick={() => scrollToSection('down')} aria-label="Scroll down">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none"><polygon points="12,18 4,8 20,8" fill="currentColor" /></svg>
          </button>
        )}
      </div>

      <section id="uc-hero" className="main-hero demo-hero">
        <div className="hero-gif-fade-left"></div>
        <div className="hero-gif-fade-right"></div>
        <h1 className="hero-page-title">AI App &amp; MCP Connections</h1>
      </section>

      <section className="ucp-content mcp-guide">
        <div className="ucp-layout">
          <h2 className="ucp-heading ucp-heading-balance">The Connection Layer Is Where Enterprise AI Risk Moved</h2>
          <p className="ucp-description">
            Most AI governance still watches what employees type. The exposure that matters now is what they connect. One click inside an approved AI tool grants a third party standing, delegated access to a company system, with no procurement, no ticket and nothing in the prompt logs. Bltz detects that connection as it is made, across ChatGPT, Claude and Gemini, and can block it before the grant exists.
          </p>

          <div className="ucp-cta" style={{ marginTop: 0, marginBottom: 20 }}>
            <button className="ucp-cta-btn" onClick={() => { navigate('/book-demo'); window.scrollTo(0, 0); }}>
              Get a Live Demo &rarr;
            </button>
          </div>

          <div className="mcp-stats">
            {HEADLINE_STATS.map(s => (
              <div key={s.value + s.tag} className={`mcp-stat mcp-stat-${s.tone}`}>
                <span className="mcp-stat-icon"><s.Icon /></span>
                <div className="mcp-stat-head">
                  <span className="mcp-stat-value">{s.value}</span>
                  <span className="mcp-stat-tag" role="img" aria-label={s.tag} title={s.tag}>
                    {s.dir === 'up' ? <ArrowUp /> : <ArrowDown />}
                  </span>
                </div>
                <span className="mcp-stat-label">{s.label}</span>
                <a className="mcp-stat-src" href={s.href} target="_blank" rel="noopener noreferrer">
                  {s.src}
                  <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor"
                    strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M7 17 17 7M9 7h8v8" />
                  </svg>
                </a>
              </div>
            ))}
          </div>

          {/* What a connection actually is */}
          <div id="section-what" className="ucp-section ucp-section-light">
            <h2 className="ucp-section-title">A Connection Is Not a Prompt. It Is a Standing Credential.</h2>
            <p className="ucp-section-desc mcp-prose">
              When an employee connects Google Drive, SharePoint, Slack, Jira or a CRM to their AI account, they complete an OAuth grant on behalf of the company. The AI vendor now holds a credential into that system and will use it whenever a future conversation seems to call for it. The grant outlives the conversation, the project and often the employee. It is a third-party integration created without the review any other third-party integration would get.
            </p>
            <p className="ucp-section-desc mcp-prose">
              On Claude the distinction between an app and an MCP server has already collapsed. Every connector on claude.ai, including the ordinary-looking ones, is a remote MCP server, and connecting one is a single authenticated call to a start-auth endpoint. We verified this directly against a signed-in account on 23 September 2026: 20 remote MCP servers and 177 plugins across the six default marketplaces, of which 88 carry at least one MCP server URL. An organisation that believes it has no MCP exposure, but allows Claude connectors, already has MCP exposure.
            </p>
            <div className="ucp-arch">
              <div className="ucp-arch-col">
                <span className="ucp-arch-caption">Where the connection is made</span>
                <div className="ucp-arch-item"><span className="ucp-arch-chip"><img src={claudeIcon} alt="" className="ucp-arch-icon" /></span><span className="ucp-arch-label">Claude connectors and MCP servers</span></div>
                <div className="ucp-arch-item"><span className="ucp-arch-chip"><img src={openaiIcon} alt="" className="ucp-arch-icon" /></span><span className="ucp-arch-label">ChatGPT app directory</span></div>
                <div className="ucp-arch-item"><span className="ucp-arch-chip"><img src={geminiIcon} alt="" className="ucp-arch-icon" /></span><span className="ucp-arch-label">Gemini app connections</span></div>
              </div>
              <div className="ucp-arch-conn">
                <svg className="ucp-arch-link" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
                  <path vectorEffect="non-scaling-stroke" d="M 0 25 C 45 25, 55 50, 100 50" />
                  <path vectorEffect="non-scaling-stroke" d="M 0 50 C 45 50, 55 50, 100 50" />
                  <path vectorEffect="non-scaling-stroke" d="M 0 75 C 45 75, 55 50, 100 50" />
                </svg>
              </div>
              <div className="ucp-arch-core">
                <img src={logoRotate} alt="Bltz AI" className="ucp-arch-core-logo" />
                <span className="ucp-arch-core-name">Bltz</span>
                <span className="ucp-arch-core-sub">Real-time connection control</span>
              </div>
              <div className="ucp-arch-conn">
                <svg className="ucp-arch-link" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
                  <path vectorEffect="non-scaling-stroke" d="M 0 50 C 45 50, 55 12.5, 100 12.5" />
                  <path vectorEffect="non-scaling-stroke" d="M 0 50 C 45 50, 55 37.5, 100 37.5" />
                  <path vectorEffect="non-scaling-stroke" d="M 0 50 C 45 50, 55 62.5, 100 62.5" />
                  <path vectorEffect="non-scaling-stroke" d="M 0 50 C 45 50, 55 87.5, 100 87.5" />
                </svg>
              </div>
              <div className="ucp-arch-col">
                <span className="ucp-arch-caption">What the grant reaches</span>
                <div className="ucp-arch-item">
                  <span className="ucp-arch-chip"><img src={driveIcon} alt="" className="ucp-arch-icon" /></span>
                  <span className="ucp-arch-chip"><img src={sharepointIcon} alt="" className="ucp-arch-icon" /></span>
                  <span className="ucp-arch-chip"><img src={outlookIcon} alt="" className="ucp-arch-icon" /></span>
                  <span className="ucp-arch-label">Document stores and mail</span>
                </div>
                <div className="ucp-arch-item">
                  <span className="ucp-arch-chip"><img src={jiraIcon} alt="" className="ucp-arch-icon" /></span>
                  <span className="ucp-arch-chip"><img src={slackIcon} alt="" className="ucp-arch-icon" /></span>
                  <span className="ucp-arch-chip"><img src={githubIcon} alt="" className="ucp-arch-icon ucp-arch-icon-white" /></span>
                  <span className="ucp-arch-label">Ticketing, chat and code hosts</span>
                </div>
                <div className="ucp-arch-item">
                  <span className="ucp-arch-chip"><img src={dbIcon} alt="" className="ucp-arch-icon ucp-arch-icon-white" /></span>
                  <span className="ucp-arch-chip"><img src={stackIcon} alt="" className="ucp-arch-icon ucp-arch-icon-white" /></span>
                  <span className="ucp-arch-label">Databases and internal APIs</span>
                </div>
                <div className="ucp-arch-item">
                  <span className="ucp-arch-chip"><img src={mcpIcon} alt="" className="ucp-arch-icon ucp-arch-icon-white" /></span>
                  <span className="ucp-arch-label">Any third-party MCP server</span>
                </div>
              </div>
            </div>
            <p className="ucp-arch-note">The connection is visible for a moment, in the browser, between a signed-in user and an approved vendor. That moment is the only place it can be governed.</p>
          </div>

          {/* Scale */}
          <div id="section-scale" className="ucp-section ucp-section-light">
            <h2 className="ucp-section-title">1. The protocol became infrastructure in sixteen months</h2>
            <p className="ucp-section-desc mcp-prose">
              The Model Context Protocol was published in November 2024. Monthly SDK downloads went from roughly 100,000 at launch to 97 million by March 2026. The official registry listed 9,652 servers in May 2026, GitHub carried 15,926 repositories tagged as MCP servers, and Anthropic put active public servers above 10,000 in its December 2025 ecosystem update. Stacklok found 41% of surveyed software organisations running MCP servers in limited or broad production.
            </p>
            <div className="mcp-chart-card">
              <AdoptionChart />
            </div>
          </div>

          {/* Data risk */}
          <div id="section-data" className="ucp-section ucp-section-light">
            <h2 className="ucp-section-title">2. The data risk is the whole corpus, not a paragraph</h2>
            <p className="ucp-section-desc mcp-prose">
              A pasted prompt exposes what one person chose to paste. A connection exposes whatever the grant can reach, continuously, at machine speed, with no person in the loop for each retrieval. The baseline is already poor: 63% of employees have pasted sensitive information into personal chatbot accounts, personally identifiable information appears in roughly 65% of shadow AI incidents and intellectual property in around 40%, and the average enterprise records 223 AI-related data policy violations a month.
            </p>
            <p className="ucp-section-desc mcp-prose">
              Connections change the shape of that exposure in three ways. The access is standing rather than momentary. It is delegated, so the AI vendor holds the credential rather than the employee. And it is machine-driven, so a single instruction can trigger retrieval across an entire document store. IBM put the 2026 global average breach cost at $4.99 million, up 12% year on year. Where shadow AI is prevalent a breach carries about $670,000 more than at organisations with little or none, and prompt injection incidents average $5.89 million.
            </p>
          </div>

          {/* Threat */}
          <div id="section-threat" className="ucp-section ucp-section-light">
            <h2 className="ucp-section-title">3. The servers on the other end are not hardened</h2>
            <p className="ucp-section-desc mcp-prose">
              Independent scans of the MCP ecosystem, using different samples and different methods, agree that the security posture did not keep pace with adoption.
            </p>
            <div className="mcp-chart-card">
              <ScanChart />
              <p className="mcp-chart-note">
                Authentication is weaker still. Astrix reviewed more than 5,200 servers in October 2025 and found only 8.5% using OAuth, with 53% relying on static API keys or personal access tokens and 79% passing credentials through environment variables.
              </p>
            </div>
            <div className="mcp-cards">
              {RISK_CARDS.map(c => (
                <div key={c.title} className="mcp-card mcp-card-risk">
                  <div className="mcp-card-head">
                    <span className="mcp-card-icon"><c.Icon /></span>
                    <span className="mcp-card-title">{c.title}</span>
                  </div>
                  <p className="mcp-card-body">{c.body}</p>
                  <div className="mcp-card-evidence">
                    <span className="mcp-card-evidence-mark"><IconEvidence /></span>
                    <p>
                      {c.evidence}
                      {c.links && (
                        <span className="mcp-card-links">
                          {c.links.map(l => (
                            <a key={l.href} href={l.href} target="_blank" rel="noopener noreferrer">{l.text}</a>
                          ))}
                        </span>
                      )}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Regulatory */}
          <div id="section-regulatory" className="ucp-section ucp-section-light">
            <h2 className="ucp-section-title">4. An unlogged connection is a regulatory gap, not just a security one</h2>
            <p className="ucp-section-desc mcp-prose">
              Every connection creates a third-party data processing relationship. Four regimes now ask organisations to evidence exactly that, and their deadlines have already passed or arrive this year.
            </p>
            <div className="mcp-cards">
              {REG_CARDS.map(c => (
                <div key={c.title} className="mcp-card mcp-card-reg">
                  <div className="mcp-card-head">
                    <span className="mcp-card-icon"><IconGavel /></span>
                    <span className="mcp-card-title">{c.title} &middot; {c.sub}</span>
                  </div>
                  <p className="mcp-card-body">{c.body}</p>
                  <div className="mcp-card-evidence">
                    <span className="mcp-card-evidence-mark"><IconEvidence /></span>
                    <p>{c.evidence}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Blind spot */}
          <div id="section-blindspot" className="ucp-section ucp-section-light">
            <h2 className="ucp-section-title">5. Why the existing stack sees none of it</h2>
            <p className="ucp-section-desc mcp-prose">
              Ask a security team how they would detect an employee connecting a third-party MCP server to their Claude account this afternoon. In most organisations the honest answer is that they would not, and the reason is structural rather than a gap in any one product.
            </p>
            <div className="mcp-cards">
              {BLIND_SPOTS.map(c => (
                <div key={c.title} className="mcp-card mcp-card-reg">
                  <div className="mcp-card-head">
                    <span className="mcp-card-icon"><IconEyeOff /></span>
                    <span className="mcp-card-title">{c.title}</span>
                  </div>
                  <p className="mcp-card-body">{c.body}</p>
                  <div className="mcp-card-evidence">
                    <span className="mcp-card-evidence-mark"><IconEvidence /></span>
                    <p>{c.evidence}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* What we shipped */}
          <div id="section-shipped" className="ucp-section ucp-section-light">
            <h2 className="ucp-section-title">What Bltz ships for this, today</h2>
            <p className="ucp-section-desc mcp-prose">
              We released app and MCP connection detection across all three major providers in September 2026. It watches the act of connecting, in the browser, where it is visible, and it names the specific application or server rather than reporting a vendor label.
            </p>
            <div className="mcp-ship">
              {SHIPPED.map(s => (
                <div key={s.value} className="mcp-ship-tile">
                  <span className="mcp-ship-icon">
                    {s.Icon ? <s.Icon /> : <img src={s.icon} alt="" />}
                  </span>
                  <span className="mcp-ship-value">{s.value}</span>
                  <span className="mcp-ship-label">{s.label}</span>
                </div>
              ))}
            </div>
            <p className="ucp-section-desc mcp-prose" style={{ marginTop: 34 }}>
              Three design decisions are worth stating plainly. We key Claude connectors on the MCP server URL rather than on the connection identifier, because that identifier is issued per account while the server URL is stable, which is what makes detection work across an organisation. We ship a catch-all policy alongside the named apps, so a connector that is not yet in any directory is still recorded rather than silently permitted. And the control point is the moment of connection, not a retrospective report, because a standing grant that has already been made is an incident rather than a decision.
            </p>
            <p className="ucp-section-desc mcp-prose">
              Safe AI adoption does not mean refusing connections. It means knowing which ones exist, who made them, what they reach, and being able to say no to a specific one without saying no to the tool. That is the difference between an AI programme a board can sign off and one that is quietly accumulating undocumented third-party access.
            </p>
          </div>

          <div id="section-cta" className="ucp-cta">
            <button className="ucp-cta-btn" onClick={() => { navigate('/book-demo'); window.scrollTo(0, 0); }}>
              See Bltz AI Connection Monitoring in Action &rarr;
            </button>
          </div>

          <span className="ucp-back-link" onClick={() => { navigate('/resources'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
            &#8592; Back to Resources
          </span>
        </div>
      </section>
    </>
  );
};

export default MCPConnectionsGuide;
